<template>
	<div class="k__file" ref="$container">
		<div class="file__dropper">
			<slot>
				<input
					type="file"
					:name="name"
					:id="id"
					:multiple="multiple"
				>
			</slot>
			<svg xmlns="http://www.w3.org/2000/svg" width="39" height="39" fill="currentColor" class="bi bi-cloud-arrow-up-fill" viewBox="0 0 16 16">
				<path d="M8 2a5.53 5.53 0 0 0-3.594 1.342c-.766.66-1.321 1.52-1.464 2.383C1.266 6.095 0 7.555 0 9.318 0 11.366 1.708 13 3.781 13h8.906C14.502 13 16 11.57 16 9.773c0-1.636-1.242-2.969-2.834-3.194C12.923 3.999 10.69 2 8 2zm2.354 5.146a.5.5 0 0 1-.708.708L8.5 6.707V10.5a.5.5 0 0 1-1 0V6.707L6.354 7.854a.5.5 0 1 1-.708-.708l2-2a.5.5 0 0 1 .708 0l2 2z" />
			</svg>
			<div class="file__dropper__label">Pesquisar arquivo</div>
			<div class="file__dropper__legend">Arraste e solte o arquivo aqui</div>
		</div>

		<ul class="k__file__list">

			<li
				v-for="file in $files"
				class="k__file__file"
			>
				<div class="k__file__file__name">
					<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-folder-fill" viewBox="0 0 16 16">
						<path d="M9.828 3h3.982a2 2 0 0 1 1.992 2.181l-.637 7A2 2 0 0 1 13.174 14H2.825a2 2 0 0 1-1.991-1.819l-.637-7a1.99 1.99 0 0 1 .342-1.31L.5 3a2 2 0 0 1 2-2h3.672a2 2 0 0 1 1.414.586l.828.828A2 2 0 0 0 9.828 3zm-8.322.12C1.72 3.042 1.95 3 2.19 3h5.396l-.707-.707A1 1 0 0 0 6.172 2H2.5a1 1 0 0 0-1 .981l.006.139z"/>
					</svg>
					<div class="file__name">
						{{ file.name }}
					</div>

					<div class="file__size">{{ filesize(file.size) }}</div>
				</div>
				<button
					type="button"
					class="k__file__file__action"
					title="Remover arquivo"
					@click="removeFile(file)"
				>
					<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash3-fill" viewBox="0 0 16 16">
						<path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5Zm-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5ZM4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06Zm6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528ZM8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5Z"/>
					</svg>
				</button>
			</li>

		</ul>
	</div>
</template>

<script setup>
import { ref, onMounted } from 'vue'

const props = defineProps({
	id: {
		type: String,
		default: ''
	},
	name: {
		type: String,
		default: ''
	},
	multiple: {
		type: Boolean,
		default: false
	}
})

const $container = ref(null)
const $input = ref(null)
const $files = ref([])

function filesize(size) {

	// Unidades de medida
	const units = ['B', 'kB', 'MB', 'GB', 'TB']

	// Calcula a melhor unidade de medida e retorna o index
	const i = Math.floor(Math.log(size) / Math.log(1024))

	// Formata o size para unidades legiveis por humanos
	const formatedSize = (size / Math.pow(1024, 1)).toFixed(2)

	return `${formatedSize} ${units[i]}`
}

function removeFile(file) {
	const datatransfer = new DataTransfer()

	const files = Array.from($input.value.files).filter(f => f !== file)

	files.forEach(f => datatransfer.items.add(f))

	$input.value.files = datatransfer.files
	$files.value = files
}

onMounted(() => {

	$input.value = $container.value.querySelector('input[type="file"]');

	$input.value.addEventListener('change', () => {
		$files.value = Array.from($input.value.files)
	})
})
</script>

<style lang="scss">

.file__dropper {
	position: relative;
	width: 100%;
	padding: 3rem 2rem;
	text-align: center;

	border: 2px dashed #CCC;
	border-radius: 1rem;

	input[type="file"]{
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		opacity: 0;
		cursor: pointer;
	}

	svg {
		color: #777;
	}
}

.file__dropper__label{
	font-weight: 700;
}

.k__file__list{
	list-style: none;
	padding-left: 0;

	margin-top: 30px;

	display: flex;
	flex-direction: column;
	gap: .5rem;
}

.k__file__file{
	display: flex;
	gap: 1rem;
}

.k__file__file__name{
	padding: .5rem;
	border-radius: .25rem;
	background: #EEE;

	flex-grow: 1;

	display: grid;
	grid-template-columns: 16px 1fr min-content;
	grid-gap: .5rem;
	align-items: center;

	.file__name{
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.file__size{
		white-space: nowrap;
	}
}

.k__file__file__action{
	padding: .5rem;
	border-radius: .25rem;
	background: #EEE;

	color: #000;

	border: none;

	transition: all .3s linear;

	&:hover{
		background: #dc3545;
		color: #FFF;
	}
}
</style>
